import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  agentIdInputSchema,
  agentOffersSchema,
  agentSchema,
  createAgentInputSchema,
  emptyAgentInputSchema,
  listAgentsOutputSchema,
  okSchema,
  renameAgentInputSchema,
} from "./agent.schemas.ts";

// Declared once. The process binds access, the `remote-agents` flag and handlers; the client
// derives its hooks.
export const agentTrpcContract = defineTrpcContract("agent", {
  list: query({ input: emptyAgentInputSchema, output: listAgentsOutputSchema }),
  get: query({ input: agentIdInputSchema, output: agentSchema }),
  offers: query({ input: emptyAgentInputSchema, output: agentOffersSchema }),
  create: mutation({ input: createAgentInputSchema, output: agentSchema }),
  rename: mutation({ input: renameAgentInputSchema, output: agentSchema }),
  delete: mutation({ input: agentIdInputSchema, output: okSchema }),
});
